const uri = '/webapi/abe/1/plans-property-definitions';

export const GET_EVENT_PROPERTY_DEFINITIONS = 'EVENT_PROPERTY_DEFINITIONS';
export const GET_EVENT_PROPERTY_DEFINITIONS_START = `${GET_EVENT_PROPERTY_DEFINITIONS}_START`;
export const GET_EVENT_PROPERTY_DEFINITIONS_SUCCESS = `${GET_EVENT_PROPERTY_DEFINITIONS}_SUCCESS`;
export const GET_EVENT_PROPERTY_DEFINITIONS_FAIL = `${GET_EVENT_PROPERTY_DEFINITIONS}_FAIL`;

export const getEventPropertyDefinitions = (offset = 0) => {
  return {
    type: GET_EVENT_PROPERTY_DEFINITIONS,
    meta: {
      xmApi: true,
      method: 'getall',
      uri,
      params: {
        offset,
      },
    },
  };
};
